import { Link, useLocation } from 'react-router';
import type { Page } from '../sitemap';

/**
 * Placeholder page: renders the sitemap metadata so the running app doubles
 * as the sitemap. Replaced area by area as each drill-down lands.
 */
export function Stub(props: { page: Page; scope: string; children?: React.ReactNode }) {
  const loc = useLocation();
  return (
    <>
      <div className="page-head">
        <div>
          <div className="overline">{props.scope}</div>
          <h1>{props.page.title}</h1>
        </div>
      </div>
      <div className="stub">
        <div className="path">{loc.pathname}</div>
        <p>{props.page.blurb}</p>
        <div className="absorbs">{props.page.absorbs} · stub — not yet built</div>
      </div>
      {props.children}
    </>
  );
}

/** The Settings index additionally lists its sub-pages as cards. */
export function SettingsIndexExtra(props: { pages: Page[]; base: string }) {
  return (
    <div className="sub-list">
      {props.pages
        .filter((p) => p.path !== 'settings')
        .map((p) => (
          <Link key={p.path} className="sub-card" to={`${props.base}/${p.path}`}>
            <b>{p.title}</b>
            <span>{p.blurb.split('.')[0]}.</span>
          </Link>
        ))}
    </div>
  );
}
